export default __webpack_public_path__ + "static/media/cd.cde7a7d7.jpg";